export function cleanParams<T extends Record<string, any>>(
  params: T
): Record<string, any> {
  return Object.fromEntries(
    Object.entries(params).filter(([_, v]) => v !== null && v !== undefined)
  );
}
